import { Instance } from 'mobx-state-tree';
import { CompletedRoutesInsightsDriverBreakdownOvertimePaginatedDtoModelBase } from './CompletedRoutesInsightsDriverBreakdownOvertimePaginatedDtoModel.base';

/* The TypeScript type of an instance of CompletedRoutesInsightsDriverBreakdownOvertimePaginatedDtoModel */
export interface CompletedRoutesInsightsDriverBreakdownOvertimePaginatedDtoModelType extends Instance<typeof CompletedRoutesInsightsDriverBreakdownOvertimePaginatedDtoModel.Type> {}

/* A graphql query fragment builders for CompletedRoutesInsightsDriverBreakdownOvertimePaginatedDtoModel */
export {
  selectFromCompletedRoutesInsightsDriverBreakdownOvertimePaginatedDto,
  completedRoutesInsightsDriverBreakdownOvertimePaginatedDtoModelPrimitives,
  CompletedRoutesInsightsDriverBreakdownOvertimePaginatedDtoModelSelector,
} from './CompletedRoutesInsightsDriverBreakdownOvertimePaginatedDtoModel.base';

/**
 * CompletedRoutesInsightsDriverBreakdownOvertimePaginatedDtoModel
 */
export const CompletedRoutesInsightsDriverBreakdownOvertimePaginatedDtoModel = CompletedRoutesInsightsDriverBreakdownOvertimePaginatedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
